// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_dict from "../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Languages$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/entities/vernacular/Languages.bs.js";
import * as N_RnrVernacularConfig from "../store/N_RnrVernacularConfig.bs.js";
import * as Lib$PorterinFusionkitSentry from "../../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.bs.js";

function getLanguage(url_params) {
  var lang = Js_dict.get(url_params, "lang");
  if (lang !== undefined) {
    var language;
    try {
      language = Languages$Catalyst.fromCode(lang);
    }
    catch (exn){
      Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, "Invalid Language");
      language = /* English */0;
    }
    if (List.mem(language, N_RnrVernacularConfig.supportedLanguages)) {
      return language;
    } else {
      return /* English */0;
    }
  } else {
    return /* English */0;
  }
}

function getCMSLanguageCode(language) {
  switch (language) {
    case /* Hindi */1 :
        return "hi-IN";
    case /* Kannada */2 :
        return "kn-IN";
    case /* English */0 :
    case /* Tamil */3 :
    case /* Telugu */4 :
    case /* Marathi */5 :
    case /* Malayalam */6 :
    case /* Bangla */7 :
        return "en";
    
  }
}

export {
  getLanguage ,
  getCMSLanguageCode ,
  
}
/* Lib-PorterinFusionkitSentry Not a pure module */
